import React, { Component } from "react";
import ProductCard from "../../../../base/features/blocks/ProductCard";
import Image from "../../../../base/features/micro/Image";
import Spinner from "../../../../base/features/micro/Spinner";
import { apiService } from "../../../../base/utils/service";
import { MdClose } from "react-icons/md";
import { FiChevronDown } from "react-icons/fi";
import ConnectionsModal from "../../../../base/features/blocks/ConnectionsModal";

class CustomerCartsDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopUid: window.location.pathname.split("/")[2],
      cartId: window.location.pathname.split("/")[4],
      cartDetail: null,
      connectionsModal: false,
    };
  }
  componentDidMount() {
    this.getCartDetail();
  }
  getCartDetail() {
    apiService(
      `v1/shops/${this.state.shopUid}/carts/${this.state.cartId}`
    ).then((data) => {
      if (data) {
        this.setState({
          cartDetail: data,
        });
      }
    });
  }

  render() {
    return (
      <div className="container-fluid px-0">
        {this.state.cartDetail ? (
          <div className="row mx-0">
            <div
              className="col-12 px-4 py-3 w-auto position-fixed border-bottom bg-white"
              style={{ top: "0", right: "0", left: "0", zIndex: "99" }}
            >
              <div className="row mx-0 px-0 mb-4">
                <div className="col px-0 fs-4 fw-bold">سبد خرید</div>
                <div className="col-auto px-0">
                  <MdClose size={28} onClick={() => window.history.back()} />
                </div>
              </div>
              <div
                className="row mx-0 p-2 rounded14 border mb-4"
                onClick={() => this.setState({ connectionsModal: true })}
              >
                <div className="col-auto px-1">
                  <Image
                    imageUri={this.state.cartDetail.user.image}
                    imageHeight={"40"}
                    imageWidth={"40"}
                    imgClassName={"rounded28 img-cover"}
                    isProfile={true}
                    extraClassName={"p-0 img-contain"}
                  />
                </div>
                <div className="col px-1">
                  <p className="fw-bold mb-0 fs-6">
                    {this.state.cartDetail.user.name}
                  </p>
                  <p className="fw-bold mb-0 small text-secondary">
                    {this.state.cartDetail.user.phone}
                  </p>
                </div>
                <div className="col-auto px-2 align-self-center">
                  <FiChevronDown size={19} />
                </div>
              </div>
              <p className="fw-bolder fs-6 color-main mb-0">محصولات</p>
            </div>
            <div className="row mx-0 px-0" style={{ marginTop: "200px" }}>
              {this.state.cartDetail.items.map((product, p) => (
                <div key={p} className="col-12 px-0 border-bottom">
                  <ProductCard
                    product={product.product}
                    shopUid={this.state.shop_uid}
                    payable_price={product.payable_price}
                    quantity={product.quantity}
                    isOrder={true}
                  />
                </div>
              ))}
            </div>
            <div
              className="row mx-0 w-auto p-4 position-fixed border-top bg-white"
              style={{ bottom: "0", right: "0", left: "0", zIndex: "99" }}
            >
              <div className="col px-1 text-secondary">جمع کل</div>
              <div className="col-auto px-1">
                <p
                  className="fs-4 fw-bold mb-0"
                  style={{
                    color: this.state.cartDetail.payable_price.color,
                  }}
                >
                  {this.state.cartDetail.payable_price.title}
                  <span className="fs-7 me-1">
                    {this.state.cartDetail.payable_price.currency}
                  </span>
                </p>
              </div>
            </div>
            <ConnectionsModal
              phone={this.state.cartDetail.user.phone}
              connectionsModalChange={(value) =>
                this.setState({ connectionsModal: value })
              }
              connectionsModal={this.state.connectionsModal}
            />
          </div>
        ) : (
          <div className="mt-5">
            <Spinner />
          </div>
        )}
      </div>
    );
  }
}

export default CustomerCartsDetail;
